<template>
  <!-- Table Container Card -->
  <b-card id="page-logs-systems" no-body class="mb-0 p-2 user-logs-card">
    <b-card-header
      class="pl-0 pr-0 d-flex align-items-between justify-content-center"
    >
      <b-col cols="12">
        <b-card-title
          ><h2>{{ $t(label("title-user-logs-systems")) }}</h2></b-card-title
        >
      </b-col>
    </b-card-header>

    <Filterss
      :fields="fildsToFilters"
      :model="model"
      :select-pagination="filterSelectPagination"
      @filter-applied="applyFilters"
      @filter-reset="resetFilters"
      @select-search="handleFilterSelectSearch"
      @select-load-more="handleFilterSelectLoadMore"
    />

    <!-- Table for larger devices -->
    <div class="user-logs-table-wrapper d-none d-lg-block">
      <b-table
        id="user-logs-table"
        responsive
        :head-variant="headVariant"
        :striped="striped"
        :bordered="bordered"
        :borderless="borderless"
        :outlined="outlined"
        :per-page="perPage"
        :busy="loading"
        :items="items"
        :fields="fields"
        class="user-logs-table shadow-sm rounded"
      >
      <template #head()="data">
        <span class="text-black">{{
          $t(labelHeader(data.label))
        }}</span>
      </template>

      <template #cell(user)="data">
        <div class="user-log-user">
          <strong>{{ data.item.nameUser || "-" }}</strong>
          <small v-if="data.item.emailUser" class="text-muted">
            {{ data.item.emailUser }}
          </small>
        </div>
      </template>

      <template #cell(descriptionMovement)="data">
        <div class="user-log-description">
          <span>{{ data.item.descriptionMovement || "-" }}</span>
          <small v-if="data.item.messageError" class="d-block text-danger mt-50">
            {{ data.item.messageError }}
          </small>
        </div>
      </template>

      <template #cell(httpMethod)="data">
        <b-badge :variant="methodVariant(data.item.httpMethod)">
          {{ data.item.httpMethod || "-" }}
        </b-badge>
      </template>

      <template #cell(endpoint)="data">
        <code>{{ data.item.endpoint || "-" }}</code>
      </template>

      <template #cell(responseStatusCode)="data">
        <b-badge :variant="statusVariant(data.item.responseStatusCode)">
          {{ formatStatus(data.item.responseStatusCode) }}
        </b-badge>
      </template>

      <template #cell(ipAddress)="data">
        <span class="text-monospace">{{ data.item.ipAddress || "-" }}</span>
      </template>

      <template #cell(createdAt)="data">
        {{ dateFormat(data.item.createdAt) }}
      </template>

        <template #table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner class="align-middle ml-50"></b-spinner>
            <strong>{{ $t("loading") }}...</strong>
          </div>
        </template>
      </b-table>
    </div>

    <!-- pagination -->
    <div class="mx-2 mt-1 d-none d-lg-block">
      <b-row>
        <b-col cols="12" md="2" class="mb-2">
          <b-form-group class="mb-0">
            <label class="d-inline-block text-sm-left mr-50">
              {{ $t("perPage") }}
            </label>
            <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
              @change="handlePerPageChange"
              class="w-50"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="10"
          class="d-flex align-items-center justify-content-end"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            pills
            @change="handlePageChange"
            first-number
            last-number
          >
            <template #prev-text>
              <feather-icon size="18" icon="ChevronLeftIcon" />
            </template>
            <template #next-text>
              <feather-icon size="18" icon="ChevronRightIcon" />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </div>

    <!-- List for mobile devices -->
    <div id="list-container" class="d-block d-lg-none mt-1 list-container">
      <b-list-group>
        <b-list-group-item
          v-for="item in items"
          :key="item.id"
          class="user-log-mobile-card d-flex flex-column align-items-start border border-primary rounded mb-1"
        >
          <div class="d-flex w-100 justify-content-between mb-1">
            <div class="user-log-user">
              <strong>{{ item.nameUser || "-" }}</strong>
              <small v-if="item.emailUser" class="text-muted">
                {{ item.emailUser }}
              </small>
            </div>
            <b-badge :variant="statusVariant(item.responseStatusCode)">
              {{ formatStatus(item.responseStatusCode) }}
            </b-badge>
          </div>
          <p class="mb-1">
            {{ item.descriptionMovement || "-" }}
          </p>
          <p v-if="item.messageError" class="mb-1 text-danger">
            <strong>{{ $t(labelHeader("errorMessage")) }}: </strong>
            {{ item.messageError }}
          </p>
          <p class="m-0">
            <strong>{{ $t(labelHeader("method")) }}: </strong>
            <b-badge :variant="methodVariant(item.httpMethod)">
              {{ item.httpMethod || "-" }}
            </b-badge>
          </p>
          <p class="m-0">
            <strong>{{ $t(labelHeader("endpoint")) }}: </strong>
            <code>{{ item.endpoint || "-" }}</code>
          </p>
          <p class="m-0">
            <strong>{{ $t(labelHeader("ipAddress")) }}: </strong>
            <span class="text-monospace">{{ item.ipAddress || "-" }}</span>
          </p>
          <p class="m-0">
            <strong>{{ $t(labelHeader("datetime")) }}: </strong>
            {{ dateFormat(item.createdAt) }}
          </p>
        </b-list-group-item>
        <b-list-group-item v-if="items.length == 0" class="text-center">
          {{ $t("notRegister") }}
        </b-list-group-item>
        <b-list-group-item v-if="loading">
          <b-spinner variant="success"></b-spinner>
        </b-list-group-item>
      </b-list-group>
    </div>
  </b-card>
</template>
<script>
import _ from "lodash";
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BPagination,
  BToast,
  BSpinner,
  BBadge,
  VBTooltip,
  BTooltip,
  BFormSelect,
  BFormGroup,
  BCardGroup,
  BCardBody,
  BListGroup,
  BListGroupItem,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import Filterss from "../components/filters/Filterss.vue";
import {
  allUsers,
  getUsersEndpointLogs,
} from "@core/api/request/user.js";
import { getParamsAll } from "@core/utils/utils";

export default {
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BPagination,
    BToast,
    BSpinner,
    BBadge,
    BFormSelect,
    BFormGroup,
    BTooltip,
    Filterss,
    BCardGroup,
    BCardBody,
    BListGroup,
    BListGroupItem,
    BDropdown,
    BDropdownItem,
  },
  directives: {
    "b-tooltip": BTooltip,
    Ripple,
  },
  data: () => ({
    model: "binnacle",
    loading: false,
    totalRows: 0,
    currentPage: 1,
    perPage: 100,
    pageOptions: [10, 50, 100],
    hasNextPage: true,
    items: [],
    users: [],
    userSearch: "",
    userCurrentPage: 0,
    userTotalPages: 0,
    userPerPage: 100,
    userHasNextPage: true,
    userLoading: false,
    userRequestVersion: 0,
    headVariant: "light",
    striped: false,
    outlined: false,
    bordered: true,
    borderless: false,
    fields: [
      { label: "user", key: "user", sortable: false },
      {
        label: "movementDescription",
        key: "descriptionMovement",
        sortable: false,
      },
      { label: "method", key: "httpMethod", sortable: false },
      { label: "endpoint", key: "endpoint", sortable: false },
      {
        label: "responseStatus",
        key: "responseStatusCode",
        sortable: false,
      },
      { label: "ipAddress", key: "ipAddress", sortable: false },
      { label: "datetime", key: "createdAt", sortable: false },
    ],
    fildsToFilters: [
      {
        name: "name",
        title: "logName",
        placeholder: "logName",
        type: "search",
        visible: true,
      },
      {
        name: "idUser",
        title: "user",
        placeholder: "user",
        type: "select",
        options: [],
        visible: true,
        multiple: false,
        close: true,
      },
    ],
    appliedFilters: {},
  }),

  computed: {
    filterSelectPagination() {
      return {
        idUser: {
          hasNextPage: this.userHasNextPage,
          loading: this.userLoading,
        },
      };
    },
  },

  watch: {},
  created() {
    this.loadData();
    this.loadUsers({ reset: true });
  },
  mounted() {
    const listContainer = document.getElementById("list-container");
    if (listContainer) {
      listContainer.addEventListener("scroll", this.handleScroll);
    }
  },
  beforeDestroy() {
    const listContainer = document.getElementById("list-container");
    if (listContainer) {
      listContainer.removeEventListener("scroll", this.handleScroll);
    }
  },
  methods: {
    async loadUsers({ reset = false } = {}) {
      if (!reset && (this.userLoading || !this.userHasNextPage)) {
        return;
      }

      if (reset) {
        this.userCurrentPage = 0;
        this.userTotalPages = 0;
        this.userHasNextPage = true;
        this.users = [];
        this.updateUserFilterOptions([]);
      }

      const requestedPage = reset ? 1 : this.userCurrentPage + 1;
      const requestSearch = this.userSearch;
      const requestVersion = ++this.userRequestVersion;
      this.userLoading = true;

      try {
        const query = [
          `page,${requestedPage}`,
          `rows,${this.userPerPage}`,
        ];
        if (requestSearch) {
          query.push(`name,${requestSearch}`);
        }

        const response = await allUsers(getParamsAll(query));
        if (
          requestVersion !== this.userRequestVersion ||
          requestSearch !== this.userSearch
        ) {
          return;
        }

        const data = _.get(response, "data");
        const items = Array.isArray(data?.items) ? data.items : [];
        const options = items
          .map((user) => ({
            idUser: Number(user?.idUser),
            label:
              user?.name ||
              user?.email ||
              (user?.idUser ? `#${user.idUser}` : ""),
          }))
          .filter(
            (user) =>
              Number.isInteger(user.idUser) &&
              user.idUser > 0 &&
              user.label,
          )
          .map((user) => ({
            label: user.label,
            value: String(user.idUser),
          }));

        if (reset) {
          this.users = options;
        } else {
          const loaded = new Set(this.users.map((user) => user.value));
          this.users = [
            ...this.users,
            ...options.filter((user) => !loaded.has(user.value)),
          ];
        }

        this.updateUserFilterOptions(this.users);
        this.userCurrentPage = requestedPage;
        this.userTotalPages =
          Number(data?.totalPages) ||
          Math.ceil((Number(data?.totalRows) || 0) / this.userPerPage);
        this.userHasNextPage =
          this.userCurrentPage < this.userTotalPages ||
          options.length === this.userPerPage;
      } catch (error) {
        if (requestVersion === this.userRequestVersion) {
          this.userHasNextPage = false;
          this.alertToast(
            "danger",
            "Error",
            error.message,
            "AlertTriangleIcon",
          );
        }
      } finally {
        if (requestVersion === this.userRequestVersion) {
          this.userLoading = false;
        }
      }
    },

    updateUserFilterOptions(users) {
      const field = this.fildsToFilters.find(
        (item) => item.name === "idUser",
      );
      if (field) {
        field.options = users;
      }
    },

    searchUsers(query) {
      this.userSearch = String(query || "").trim();
      return this.loadUsers({ reset: true });
    },

    loadMoreUsers() {
      return this.loadUsers();
    },

    handleFilterSelectSearch({ fieldName, value }) {
      if (fieldName === "idUser") {
        return this.searchUsers(value);
      }
      return Promise.resolve();
    },

    async handleFilterSelectLoadMore({ fieldName, done }) {
      if (fieldName === "idUser") {
        await this.loadMoreUsers();
      }
      if (typeof done === "function") {
        done();
      }
    },

    async loadData() {
      try {
        this.loading = true;
        const params = this.chargeParams();
        const [logsResp] = await Promise.all([getUsersEndpointLogs(params)]);

        const logs = _.get(logsResp, "data");
        this.items = Array.isArray(logs?.items) ? logs.items : [];
        this.totalRows = logs?.totalRows || 0;
        this.hasNextPage = logs?.currentPage < logs?.totalPages || 0;
      } catch (error) {
        this.alertToast("danger", "Error", error.message, "AlertTriangleIcon");
        console.error("Error loading data", error.message);
      } finally {
        this.loading = false;
      }
    },
    async loadLogsInfinity() {
      if (!this.hasNextPage) return;
      try {
        this.loading = true;
        const params = this.chargeParams();
        getUsersEndpointLogs(params)
          .then((resp) => {
            const data = _.get(resp, "data", []);
            if (Array.isArray(data?.items)) {
              // Agregar nuevos elementos sin sobreescribir los existentes
              this.items = [...this.items, ...data?.items];
            }
            this.totalRows = data?.totalRows || 0;
            // Verificar si hay más páginas
            this.hasNextPage = data?.currentPage < data?.totalPages || false;
            this.loading = false;
          })
          .catch((error) => {
            this.alertToast(
              "danger",
              "Error",
              error.message,
              "AlertTriangleIcon",
            );
            console.error("Error loading products infinitely", error);
          });
      } catch (error) {
        this.alertToast("danger", "Error", error.message, "AlertTriangleIcon");
        console.error("Error cargando productos infinitamente", error.message);
      }
    },
    label(field) {
      return `pages.binnacle.table.${field}`;
    },
    labelHeader(field) {
      return `pages.binnacle.table.tableHeader.${field}`;
    },
    chargeParams() {
      const arrParams = [
        `page,${this.currentPage}`,
        `rows,${this.perPage}`,
      ];

      const name = String(this.appliedFilters.name || "").trim();
      const idUser = String(this.appliedFilters.idUser || "").trim();

      if (name) {
        arrParams.push(`name,${name}`);
      }

      if (/^[1-9]\d*$/.test(idUser)) {
        arrParams.push(`idUser,${idUser}`);
      }

      return getParamsAll(arrParams);
    },

    dateFormat(date) {
      if (!date) return "-";

      const fecha = new Date(date);
      if (Number.isNaN(fecha.getTime())) return "-";

      const dia = fecha.getDate().toString().padStart(2, "0");
      const mes = (fecha.getMonth() + 1).toString().padStart(2, "0");
      const anio = fecha.getFullYear();
      const hours = fecha.getHours();
      const period = hours >= 12 ? "PM" : "AM";
      const formattedHours = (hours % 12 || 12).toString().padStart(2, "0");
      const minutes = fecha.getMinutes().toString().padStart(2, "0");

      return `${dia}/${mes}/${anio} ${formattedHours}:${minutes} ${period}`;
    },
    methodVariant(method) {
      const variants = {
        POST: "light-success",
        PUT: "light-warning",
        DELETE: "light-danger",
        PATCH: "light-info",
      };

      return variants[String(method || "").toUpperCase()] || "light-secondary";
    },
    statusVariant(status) {
      const statusCode = Number(status);
      if (statusCode >= 200 && statusCode < 300) return "light-success";
      if (statusCode >= 400) return "light-danger";
      if (statusCode >= 300) return "light-warning";
      return "light-secondary";
    },
    formatStatus(status) {
      return status === null || status === undefined || status === ""
        ? "-"
        : status;
    },
    tagsColor(type) {
      if (type) return "light-success";
      else return "light-danger";
    },
    async handleScroll() {
      const container = document.getElementById("list-container");
      if (
        container.scrollTop + container.clientHeight >=
        container.scrollHeight - 1
      ) {
        this.currentPage++;
        await this.loadLogsInfinity();
      }
    },

    handlePageChange(value) {
      this.currentPage = value;
      this.hasNextPage = true;
      this.loadData();
    },

    handlePerPageChange() {
      this.currentPage = 1;
      this.hasNextPage = true;
      this.loadData();
    },

    validateFilters(filters) {
      if (filters.name && !String(filters.name).trim()) {
        console.error("El filtro de nombre no es válido.");
        return false;
      }

      if (
        filters.idUser !== null &&
        filters.idUser !== undefined &&
        filters.idUser !== "" &&
        !/^[1-9]\d*$/.test(String(filters.idUser).trim())
      ) {
        console.error("El identificador del usuario no es válido.");
        return false;
      }

      return true;
    },

    applyFilters(filters) {
      if (this.validateFilters(filters)) {
        this.appliedFilters = filters;
        this.currentPage = 1;
        this.hasNextPage = true;
        this.loadData();
      } else {
        console.error("Filtros no aplicados debido a validaciones fallidas.");
      }
    },

    resetFilters() {
      this.appliedFilters = {};
      this.currentPage = 1;
      this.hasNextPage = true;
      this.loadData();
      this.userSearch = "";
      this.loadUsers({ reset: true });
    },
  },
};
</script>

<style lang="scss">
#page-logs-systems {
  width: 100%;
  max-width: 100%;
  min-width: 0;

  .per-page-selector {
    width: 90px;
  }

  .user-logs-table-wrapper {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;

    .table-responsive {
      width: 100%;
      max-width: 100%;
      margin-bottom: 0;
      overflow-x: auto;
    }
  }

  .user-logs-table {
    width: 100%;
    min-width: 1180px;
    margin-bottom: 0;
    table-layout: fixed;

    th,
    td {
      vertical-align: middle;
      white-space: normal;
      overflow-wrap: anywhere;
      word-break: break-word;
    }

    th:nth-child(1),
    td:nth-child(1) {
      width: 190px;
    }

    th:nth-child(2),
    td:nth-child(2) {
      width: 310px;
    }

    th:nth-child(3),
    td:nth-child(3) {
      width: 85px;
      text-align: center;
    }

    th:nth-child(4),
    td:nth-child(4) {
      width: 220px;
    }

    th:nth-child(5),
    td:nth-child(5) {
      width: 105px;
      text-align: center;
    }

    th:nth-child(6),
    td:nth-child(6) {
      width: 135px;
    }

    th:nth-child(7),
    td:nth-child(7) {
      width: 145px;
    }
  }

  .list-container {
    width: 100%;
    max-width: 100%;
    height: 60vh;
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .user-log-mobile-card {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    overflow: hidden;

    > .d-flex {
      min-width: 0;
      gap: 0.75rem;
    }

    > p {
      width: 100%;
    }

    p,
    code,
    span,
    small {
      max-width: 100%;
      overflow-wrap: anywhere;
      word-break: break-word;
    }
  }

  .user-log-user {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    min-width: 0;
    max-width: 100%;
  }

  .user-log-description {
    display: block;
    width: 100%;
    white-space: normal;
  }
}

@media (max-width: 575.98px) {
  #page-logs-systems {
    padding: 1rem !important;

    .card-header,
    .card-body {
      padding-right: 0;
      padding-left: 0;
    }

    .user-log-mobile-card {
      padding: 1rem;
    }
  }
}
</style>
